"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @example
 * 	const $tabButtons = $element.querySelector('.tab-buttons') as HTMLElement;
 * 	const $tabTabs = $element.querySelector('.tab-panel') as HTMLElement;
 * 	new Tab($tabButtons, $tabTabs);
 */
class Tab {
    constructor(buttonsContainer, tabsContainer, options) {
        this.activeTabIndex = 0;
        this.buttonsContainer = buttonsContainer;
        this.tabsContainer = tabsContainer;
        this.options = Object.assign({ buttonSelector: ':scope .tab-buttons__list > .button-primary', tabSelector: ':scope > .tab-panel__item', activeButtonClass: 'button-primary--active', activeTabClass: 'tab-panel__item--active', beforeChange: () => { }, afterChange: () => { }, afterInit: () => { } }, options);
        if (this.buttonsContainer && this.tabsContainer) {
            this.buttons = Array.from(this.buttonsContainer.querySelectorAll(this.options.buttonSelector));
            this.tabs = Array.from(this.tabsContainer.querySelectorAll(this.options.tabSelector));
            this.activeButton = this.buttons.find(button => button.classList.contains(this.options.activeButtonClass));
            this.activeTab = this.tabs.find(tab => tab.classList.contains(this.options.activeTabClass));
            this.initialize();
        }
        else {
            this.buttons = [];
            this.tabs = [];
        }
    }
    /** Инициализирует функциональность вкладок, устанавливая слушатели событий. */
    initialize() {
        this.buttons.forEach(button => {
            button.addEventListener('click', () => {
                if (button !== this.activeButton) {
                    const tabNum = button.getAttribute('data-tab-num');
                    if (tabNum !== null) {
                        this.activateTab(tabNum, true);
                    }
                }
            });
        });
        this.options.afterInit();
    }
    /**
     * Деактивирует переданную кнопку.
     *
     * @param button Кнопка для деактивации.
     */
    unsetActiveStateButton(button) {
        button.classList.remove(this.options.activeButtonClass);
        button.ariaSelected = 'false';
        button.removeAttribute('tabindex');
    }
    /**
     * Активирует переданную кнопку.
     *
     * @param button Кнопка для активации.
     */
    setActiveStateButton(button) {
        button.classList.add(this.options.activeButtonClass);
        button.ariaSelected = 'true';
        button.setAttribute('tabindex', '-1');
        button.blur();
    }
    /**
     * Активирует вкладку, соответствующую переданному номеру.
     *
     * @param num Идентификатор вкладки для активации.
     */
    activateTab(num, isTrust = false) {
        this.options.beforeChange();
        this.activeTabIndex = +num;
        const lastTabNum = this.buttons.findIndex(button => button === this.activeButton);
        if (this.activeButton) {
            this.unsetActiveStateButton(this.activeButton);
        }
        this.activeButton = this.buttons.find(button => button.getAttribute('data-tab-num') === num);
        if (this.activeButton) {
            this.setActiveStateButton(this.activeButton);
        }
        if (this.activeTab) {
            this.activeTab.classList.remove(this.options.activeTabClass);
            this.activeTab.hidden = true;
        }
        this.activeTab = this.tabs.find(tab => tab.getAttribute('data-tab-num') === num);
        if (this.activeTab) {
            this.activeTab.classList.add(this.options.activeTabClass);
            this.activeTab.hidden = false;
        }
        this.buttonsContainer.dispatchEvent(new CustomEvent('change-tab', {
            detail: {
                tabNum: num,
                lastTabNum: `${lastTabNum}`,
                isTrust,
            },
        }));
        this.options.afterChange();
    }
}
exports.default = Tab;
